import { gql } from '@apollo/client';

export const getPremiumUserQuery = gql`
    query GetPremiumUser {
        user {
            id
            appUserId
            role
            tariff
            subscriptionExpiresAt
            subscription {
                id
                productKey
                amount
                subscriptionExpiresAt
                subscriptionCanceledAt
            }
        }
    }
`;

export const myRenewalMissedQuery = gql`
    query MyRenewalMissed {
        myRenewalMissed
    }
`;

export const paymentCheckoutQuery = gql`
    query PaymentCheckout($paymentId: String!) {
        paymentCheckout(paymentId: $paymentId) {
            status
            user {
                id
                appUserId
                role
                tariff
                subscriptionExpiresAt
                subscription {
                    id
                    productKey
                    amount
                    subscriptionExpiresAt
                    subscriptionCanceledAt
                }
            }
        }
    }
`;

export const createPaymentInvoiceMutation = gql`
    mutation CreatePaymentInvoice($productKey: String!, $app: SubscriptionApp) {
        createPaymentInvoice(input: { productKey: $productKey, app: $app }) {
            paymentId
            invoiceUrl
        }
    }
`;

export const startTrialMutation = gql`
    mutation StartTrial($app: SubscriptionApp) {
        startTrial(app: $app) {
            ok
            errorMessage
            user {
                id
                appUserId
                role
                tariff
                subscriptionExpiresAt
            }
        }
    }
`;

export const cancelMySubscriptionMutation = gql`
    mutation CancelMySubscription {
        cancelMySubscription {
            id
            subscriptionCanceledAt
        }
    }
`;
